import React, { FC, useState } from 'react'
import cn from 'clsx'
import { CaretRight, CloseIconLarge } from '@components/icons'
import { IconLogo } from '@components/ui/Logo'

const ns = `site-header`
const block = `nav-menu-l1`

interface NavMenuL1Props {
  navigation?: any
  closeMenu?: any
  primaryNavMouseOver?: any
  isOpen: boolean
  closeL2Menu?: any
}

interface PrimaryNavItemsProps {
  primaryNavItems?: any
  primaryNavMouseOver?: any
  closeL2Menu?: any
  closeMenu?: any
}

interface SecondaryNavItemsProps {
  secondaryNavItems?: any
  closeMenu?: any
}

const PrimaryNavItems: FC<PrimaryNavItemsProps> = ({
  primaryNavItems,
  primaryNavMouseOver,
  closeL2Menu,
  closeMenu,
}) => {
  return primaryNavItems.map((navItem: any, index: number) => (
    <React.Fragment key={navItem.linkLabel || navItem.label}>
      {navItem.linkLabel && (
        <li
          data-index={index}
          className={`${ns}__${block}__primary-nav-item`}
          onMouseOver={primaryNavMouseOver}
          onClick={primaryNavMouseOver}
        >
          <button>
            <p className={`nav-link-label`}>{navItem.linkLabel}</p>
            <div className="caret">
              <CaretRight width={16} height={16} />
            </div>
          </button>
        </li>
      )}
      {navItem.label && (
        <li
          data-index={index}
          className={`${ns}__${block}__primary-nav-item`}
          onMouseOver={closeL2Menu}
        >
          <a href={navItem.target} onClick={closeMenu}>
            <p className={`nav-link-label`}>{navItem.label}</p>
          </a>
        </li>
      )}
    </React.Fragment>
  ))
}

const SecondaryNavItems: FC<SecondaryNavItemsProps> = ({
  secondaryNavItems,
  closeMenu,
}) => {
  return secondaryNavItems.map((navItem: any) => (
    <li key={navItem.label} className={`${ns}__${block}__secondary-nav-item`}>
      {navItem.label && (
        <a href={navItem.target} onClick={closeMenu}>
          {navItem.label}
        </a>
      )}
    </li>
  ))
}

const NavMenuL1: FC<NavMenuL1Props> = ({
  navigation,
  closeMenu,
  primaryNavMouseOver,
  isOpen,
  closeL2Menu,
}) => {
  return (
    <div className={cn(`${ns}__${block}`, { '--open': isOpen })}>
      <div className={`${ns}__${block}__container`}>
        <div className={`${ns}__${block}__close-icon-wrapper`}>
          <div onClick={closeMenu}>
            <CloseIconLarge />
          </div>
        </div>
        <h3
          className={`${ns}__${block}__primary-nav-title`}
          onMouseEnter={closeL2Menu}
        >
          {navigation?.primaryNavTitle}
        </h3>
        <ul>
          <PrimaryNavItems
            primaryNavItems={navigation?.primaryNavListCollection.items}
            closeL2Menu={closeL2Menu}
            primaryNavMouseOver={primaryNavMouseOver}
            closeMenu={closeMenu}
          />
        </ul>
      </div>
      <div className={`${ns}__${block}__secondary-nav-container`}>
        <ul>
          <SecondaryNavItems
            secondaryNavItems={navigation.secondaryNavListCollection.items}
            closeMenu={closeMenu}
          />
        </ul>
        <IconLogo />
      </div>
    </div>
  )
}

export default NavMenuL1
